import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './styles/element-variables.scss';
import './styles/element-ui.scss';
import store from '@/store/index.js';
import './styles/global.css';
import './utils/fonts/iconfont.css';

// import Video from 'video.js';
// import 'video.js/dist/video-js.css';
// Vue.prototype.$video = Video;
// 重新定义message
import { Message } from 'element-ui';
let messageInstance = null;
const resetMessage = (options) => {
  if (messageInstance) {
    messageInstance.close();
  }
  messageInstance = Message(options);
};
['error', 'success', 'info', 'warning'].forEach((type) => {
  resetMessage[type] = (options) => {
    if (typeof options === 'string') {
      options = {
        message: options,
      };
    }
    options.type = type;
    return resetMessage(options);
  };
});
Vue.prototype.$message = resetMessage;

//全局混入 mixin
import Mixins from './utils/mixin/mixin.js';
Vue.mixin(Mixins);

Vue.use(ElementUI);

// 横向滚动条
import { Plugin } from './utils/directive';
Vue.use(Plugin);

// 表头吸顶
import elTableSticky from './utils/el_table_sticky';
Vue.use(elTableSticky);
import './styles/el-table-sticky.scss';

/**
 * NIM 云信实例对象
 */
Vue.prototype.$nim = null; // 初始化为 null，用户登录后再初始化

/**
 * 监听用户动态操作的 Web Worker
 */
Vue.prototype.$dynamicDetector = null;

import { NewToast } from '@/components/XmToast/js/index.js';
Vue.use(NewToast);

/**
 * 无限滚动懒加载插件
 */
import infiniteScroll from 'vue-infinite-scroll';
Vue.use(infiniteScroll);

/**
 * 注册全局指令
 */
import '@/utils/custom_directives';

// 混入全局组件
import { initGlobalComponents } from './utils/install.js';
initGlobalComponents(); // 注册全局组件

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
